import React, {forwardRef} from 'react';
import {IMaskInput} from 'react-imask';

const TextMaskCustom = forwardRef((props, ref) => {
  const {onChange, mask, eager, ...other} = props;
  return (
    <IMaskInput
      {...other}
      mask={mask}
      eager={eager}
      inputRef={ref}
      onAccept={(value) => onChange({target: {name: props.name, value}})}
      overwrite
    />
  );
});

export default TextMaskCustom;